import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div className='footer'>
            <div className='container'>
                <div className='row justify-content-center'>
                    <div className='col-auto'>
                        <p style={{ marginTop: '3px', marginBottom: '-5px', fontSize: '15px' }}>&copy;Copyrights reserved by Developer</p>
                        <p style={{ marginBottom: '-2px' }}>Developer : Shamim Anowar</p>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;